import client from "../utils/client";
import { LoginUrl, profileUrl, usersUrl } from "../store/constants/api";
import { cookieConstants } from "../store/constants";
import { Cookies } from "react-cookie";

const cookies = new Cookies();

export const userService = {
  login,
  logout,
  usersList,
  addUser,
  getUser,
  updateUser,
};

async function login(username, password, gRecaptchaResponse) {
  let data = {
    email_or_mobile: username,
    password: password,
    gRecaptchaResponse: gRecaptchaResponse,
  };
  return client
    .post(LoginUrl, data)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function logout() {
  cookies.remove(cookieConstants.TOKEN, { path: "/" });
  cookies.remove(cookieConstants.USER, { path: "/" });
}

function usersList(pageID, perPage, searchInput, role = "") {
  let searchQuery = "";

  if (searchInput !== "") {
    searchQuery = "&s=" + searchInput;
  }

  console.log(role, "xx");

  if (role !== "") {
    searchQuery += "&role=" + role;
  }

  return client
    .get(usersUrl + "?page=" + pageID + "&per_page=" + perPage + searchQuery)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function addUser(formDate) {
  return client
    .post(usersUrl + "/create", formDate)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function getUser() {
  return client
    .get(profileUrl)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function updateUser(formDate) {
  const profileData = new FormData();
  Object.keys(formDate).forEach((key) => {
    profileData.append(key, formDate[key]);
  });

  return client
    .post(profileUrl + "/update", profileData)
    .then((response) => {
      return response;
    })
    .catch(handleResponse);
}

function handleResponse(response) {
  response = response.response; //JSON.parse(response);
  var data = response.data;
  if (!response.ok) {
    if (response.status === 401) {
      logout();
      window.location.reload(true);
    }
    const error = data.errors; //(data && data.message) || response.statusText;
    return Promise.reject(error);
  }

  return data;
}
